export const testimonialsData = [
  {
    key: "1",
    userName: "Darlee Robertson",
    avatar: "assets/img/profiles/avatar-19.jpg",
    role: "Facility Manager",
    rating: 5,
    content: "Project was received ontime without any mistake",
    createdAt: "25 Sep 2023, 01:22pm",
    status: "Inactive",
  },
  {
    key: "2",
    userName: "Sharon Roy",
    avatar: "assets/img/profiles/avatar-20.jpg",
    role: "Installer",
    rating: 5,
    content: "It help us to manage, track & do more business",
    createdAt: "29 Sep 2023, 08:12 am",
    status: "Inactive",
  },
  {
    key: "3",
    userName: "Vaughan",
    avatar: "assets/img/profiles/avatar-21.jpg",
    role: "Senior Manager",
    rating: 5,
    content: "Brillant tool to manage leads & projects",
    createdAt: "02 Oct 2023, 10:15 am",
    status: "Active",
  },
  {
    key: "4",
    userName: "Jessica",
    avatar: "assets/img/profiles/avatar-23.jpg",
    role: "Test Engineer",
    rating: 5,
    content: "Very responsive and accurate with suggestions",
    createdAt: "11 Oct 2023, 02:32 pm",
    status: "Active",
  },
  {
    key: "5",
    userName: "Carol Thomas",
    avatar: "assets/img/profiles/avatar-16.jpg",
    role: "UI /UX Designer",
    rating: 5,
    content: "Happy with measurable on lead management",
    createdAt: "4 Nov 2023, 04:22 pm",
    status: "Inactive",
  },
  {
    key: "6",
    userName: "Dawn Mercha",
    avatar: "assets/img/profiles/avatar-22.jpg",
    role: "Technician",
    rating: 5,
    content: "Pipeline are great for tracking process",
    createdAt: "16 Nov 2023, 10:51 pm",
    status: "Active",
  },
  {
    key: "7",
    userName: "Rachel Hampton",
    avatar: "assets/img/profiles/avatar-24.jpg",
    role: "Software Developer",
    rating: 5,
    content: "It have complete visiblity of clients & interactions",
    createdAt: "25 Nov 2023, 3:43 pm",
    status: "Active",
  },
  {
    key: "8",
    userName: "Jonelle Curtiss",
    avatar: "assets/img/profiles/avatar-25.jpg",
    role: "Supervisor",
    rating: 5,
    content: "Give customer best possible service & support",
    createdAt: "07 Dec 2023, 11:22 am",
    status: "Active",
  },
  {
    key: "9",
    userName: "Jonathan",
    avatar: "assets/img/profiles/avatar-26.jpg",
    role: "Team Lead Dev",
    rating: 5,
    content: "It give accurate and real time information",
    createdAt: "15 Dec 2023, 8:17 am",
    status: "Active",
  },
  {
    key: "10",
    userName: "Eric Adams",
    avatar: "assets/img/profiles/avatar-06.jpg",
    role: "HR Manager",
    rating: 5,
    content: "Most efficient process, accurate & consistent data",
    createdAt: "29 Dec 2023, 1:22 pm",
    status: "Active",
  },
];
